export enum Notifications {
  CreatedOrderSuccess = 'createdOrderSuccess',
  CreatedOrderError = 'createdOrderError',
  CancelOrderSuccess = 'cancelOrderSuccess',
  ReclaimOrderSuccess = 'reclaimOrderSuccess',
  ReclaimOrderError = 'reclaimOrderError',
  CancelOrderError = 'cancelOrderError',
  PleaseConnectWallet = 'pleaseConnectWallet',
  TryAgain = 'tryAgain',
}

export enum NotificationType {
  Submitted = 'submitted',
  Canceled = 'canceled',
  Matched = 'matched',
  Processed = 'processed',
  Transferred = 'transferred',
}

export enum NotificationPosition {
  Top = 'top',
  Bottom = 'bottom',
}
